// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._14gif{position:relative;margin-top:.25rem}.OsAAR{color:#0373f9;cursor:pointer;font-size:14px;font-size:.875rem;font-weight:500;line-height:17.5px;line-height:1.09375rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}._3nKUM{margin-left:1.2rem;margin-top:1.25rem}._2zbD6{margin-bottom:.5rem;list-style:disc}._16f3e{font-size:16px;font-size:1rem;font-weight:400;line-height:26px;line-height:1.625rem;font-family:var(--base-font)}", ""]);
// Exports
exports.locals = {
	"root": "_14gif",
	"cta": "OsAAR",
	"ul": "_3nKUM",
	"list": "_2zbD6",
	"name": "_16f3e"
};
module.exports = exports;
